function seedCost(state={seedCost: 12}, action) {
    switch (action.type) {
        case "SEED_COST_CHANGED":
            return Object.assign({}, state, {seedCost: action.payload});
        default:
            return state;
    }
}
export default seedCost;